module.exports = __webpack_public_path__ + "img/bg-bottom-left.858a3f92.webp";